export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const allDigitsRegex = /^\d*$/;

export const nameRegex = /^[a-zA-Z\s]*$/;
